import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import {
  SET_WEAKNESSES,
  ADD_WEAKNESS,
  PUT_WEAKNESS,
  DELETE_WEAKNESS,
  SET_RISK_WEAKNESSES,
  SET_INFINITE_WEAKNESSES,
  SET_SEARCHED_WEAKNESSES,
} from "../types/weaknessesTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { translate } from "../../utils/utils";
import { fetchAllTags } from "./tagsActionCreators";

export const setWeaknesses = (items, totalPages, sources) => ({
  type: SET_WEAKNESSES,
  payload: { items, totalPages, sources },
});

export const setInfiniteWeaknesses = (items, totalPages) => ({
  type: SET_INFINITE_WEAKNESSES,
  payload: { items, totalPages },
});

export const setSearchedWeaknesses = (items, totalPages) => ({
  type: SET_SEARCHED_WEAKNESSES,
  payload: { items, totalPages },
});

export const addWeakness = (item) => ({ type: ADD_WEAKNESS, payload: item });
export const updateWeakness = (id, data) => ({
  type: PUT_WEAKNESS,
  payload: { id: id, data },
});

export const setRiskWeaknesses = (items) => ({
  type: SET_RISK_WEAKNESSES,
  payload: items,
});

export const removeWeakness = (id) => ({ type: DELETE_WEAKNESS, payload: id });

export const fetchAllWeaknesses = (page, searchText, filter, ids, infinite) => {
  return (dispatch) => {
    dispatch(requestStarted("weakness"));
    // The anonymous half of this if/else fetched /model/weaknesses_off, so the
    // authenticated half now runs unconditionally.
    axiosInstance
      .get(
        `/model/weaknesses?page=${page}&search${
          searchText ? "=" + searchText : ""
        }&source${filter !== "all" ? "=" + filter : ""}&ids${
          ids ? (ids.length > 0 ? "=" + ids : "=[]") : ""
        }`
      )
      .then((res) => {
        const items = res.data;
        if (ids && !infinite) {
          dispatch(setRiskWeaknesses(items?.weaknesses));
        } else if (!ids && infinite) {
          if (searchText && page === 1) {
            dispatch(
              setSearchedWeaknesses(items?.weaknesses, items?.total_pages)
            );
          } else {
            dispatch(
              setInfiniteWeaknesses(items?.weaknesses, items?.total_pages)
            );
          }
        } else {
          dispatch(
            setWeaknesses(items?.weaknesses, items?.total_pages, items?.sources)
          );
        }
        dispatch(fetchAllTags());
        dispatch(requestSucceeded());
      })
      .catch((error) => {
        console.log({ error });
        dispatch(requestFailed(error.response.data));
      });
    // } else {
    //   axiosInstance
    //     .get(`/model/weaknesses_off`)
    //     .then((res) => {
    //       const items = res.data;
    //       dispatch(setWeaknesses(items));
    //       dispatch(fetchAllTags());
    //       dispatch(requestSucceeded());
    //     })
    //     .catch((error) => {
    //       console.log({ error });
    //       dispatch(requestFailed(error.response.data));
    //     });
    // }
  };
};
export const requestCreatingWeakness = (
  page,
  searchText,
  filter,
  { weaknessName, weaknessDescription, tags },
  accountId,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    const data = {
      [translate("title")]: weaknessName,
      [translate("description")]: weaknessDescription,
      tags: tags,
    };
    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }
    try {
      const res = await axiosInstance.post(`/model/weaknesses`, data);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        addWeakness({
          [translate("title")]: weaknessName,
          [translate("description")]: weaknessDescription,
          tags: tags,
        })
      );
      dispatch(fetchAllWeaknesses(page, searchText, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestUpdatingItem = (
  page,
  searchText,
  filter,
  id,
  { weaknessName, weaknessDescription, tags },
  accountId,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    const data = {
      [translate("title")]: weaknessName,
      [translate("description")]: weaknessDescription,
      tags: tags,
    };
    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }
    try {
      const res = await axiosInstance.put(`model/weakness/${id}`, data);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        updateWeakness(id, {
          [translate("title")]: weaknessName,
          [translate("description")]: weaknessDescription,
          tags: tags,
        })
      );
      dispatch(fetchAllWeaknesses(page, searchText, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeletingWeakness = (
  page,
  searchText,
  filter,
  id,
  accountType,
  accountId
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.delete(
              `model/weakness/${id}?related_account_id=${accountId}`
            )
          : await axiosInstance.delete(`model/weakness/${id}`);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(removeWeakness(id));
      dispatch(fetchAllWeaknesses(page, searchText, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
